'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _collection = require('common/collection');

var _collection2 = _interopRequireDefault(_collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function NotifierCollection() {}

_collection2['default'].extend(NotifierCollection, {
    notify: function notify(message) {

        var promises = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var notifier = _step.value;

                promises.push(notifier.notify(message));
            }

            // some notifiers might not return anything, so filter them out
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return Promise.all(promises).then(function (responses) {
            return responses.filter(function (response) {
                return response != void 0;
            });
        });
    }
});

exports['default'] = NotifierCollection;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/notifiers/collection.js
 ** module id = 692
 ** module chunks = 0 1
 **/